import { create } from 'zustand'

import { DueDateInfoApi } from 'interfaces/types/DueDate'

import { HealthToolStoreType } from './types'

export const useHealthToolStore = create<HealthToolStoreType>((set) => ({
  currentHealthToolType: '',
  setCurrentHealthToolType(currentHealthToolType: string) {
    set({ currentHealthToolType })
  },
  setDueDateInfo(data: DueDateInfoApi) {
    set({
      dueDateInfo: data,
    })
  },
  resultDueDate: 0,
  setResultDueDate(resultDueDate) {
    set({ resultDueDate })
  },
  resultBabyDOB: 0,
  setResultBabyDOB(resultBabyDOB) {
    set({ resultBabyDOB })
  },
}))
